import React from "react";
import {autoplayAssetConfig} from "../../../../data/autoplay/autoplayconfig";
import {mobViewPanelAssetConfig} from "../../../../data/mobViewPanel";
import {Icomponent} from "../../commongame/interface/Icomponent";


interface IframeworkAutoplay {
    data: {
        "AUTOPLAY_CONTAINER_X": any,
        "AUTOPLAY_CONTAINER_Y": any,
        "autoplayBaseImage": any,
        "clickedNumberButton": any,
        "unclickedNumberButton": any,
        "toggleButtonOnImage": any,
        "toggleButtonOffImage": any,
        "mobPanelButtonsImage": any,
        "meterImage": any,
        COMPONENTS: Icomponent[]
    }


}

export const frameworkAutoplay: IframeworkAutoplay = {
    data: {
        "AUTOPLAY_CONTAINER_X": 380,
        "AUTOPLAY_CONTAINER_Y": 50,
        "autoplayBaseImage": autoplayAssetConfig["autoplayBaseImage"],
        "clickedNumberButton": autoplayAssetConfig["clickedNumberButton"],
        "unclickedNumberButton": autoplayAssetConfig["unclickedNumberButton"],
        "toggleButtonOnImage": autoplayAssetConfig["toggleButtonOnImage"],
        "toggleButtonOffImage": autoplayAssetConfig["toggleButtonOffImage"],
        "mobPanelButtonsImage": mobViewPanelAssetConfig["mobPanelButtonsImage"],
        "meterImage": autoplayAssetConfig["meterImage"],
        "COMPONENTS": [
            // {
            //     "name": "backgroundImageOfAutoPlay",
            //     "image": autoplayAssetConfig["autoplayBG"],
            //     "type": "Image",
            //     "class": "",
            //     "parentLayer": "specialAnimationLayer",
            //     "visible": true,
            //     "width": 524,
            //     "height": 579,
            //     "x": 380,
            //     "y": 50,
            // },
            // {
            //     "id": "autoplayTextContainer",
            //     "name": "autoplayTextContainer",
            //     "type": "Container",
            //     "class": "",
            //     "visible": true,
            //     "x": 0,
            //     "y": 0,
            //
            //     "filterTypes": [],
            //     child: [
            //         {
            //
            //             "id": "text_autoplay1",
            //             "name": "text_autoplaySetting",
            //             "type": "Text",
            //             "x": 635,
            //             "y": 71,
            //             "height": 100,
            //             "width": 500,
            //             "text": "autoplayText_1",
            //             "scaleToFit": false,
            //             "anchor": [0.5, 0.5],
            //             "textStyle": {
            //                 fontFamily: 'Arial',
            //                 fontSize: 20,
            //                 fontStyle: 'normal',
            //                 fontWeight: 'bold',
            //                 fill: ['#d4af37', '#d4af37', '#d4af37'], // gradient
            //                 stroke: '#4a1850',
            //                 strokeThickness: 0,
            //                 dropShadow: true,
            //                 dropShadowColor: '#000000',
            //                 dropShadowBlur: 4,
            //                 dropShadowAngle: Math.PI / 6,
            //                 dropShadowDistance: 0,
            //                 wordWrap: true,
            //                 wordWrapWidth: 800
            //             }
            //         },
            //         {
            //             "id": "text_autoplay2",
            //             "name": "text_stopAutoplay",
            //             "type": "Text",
            //             "x": 458,
            //             "y": 200,
            //             "height": 100,
            //             "width": 200,
            //             "text": "autoplayText_2",
            //             "scaleToFit": false,
            //             "anchor": [0.5, 0.5],
            //             "textStyle": {
            //                 fontFamily: 'Arial',
            //                 fontSize: 15,
            //                 fontStyle: 'normal',
            //                 fontWeight: 'bold',
            //                 fill: ['#ffffff', '#ffffff', '#ffffff'], // gradient
            //                 stroke: '#4a1850',
            //                 strokeThickness: 0,
            //                 dropShadow: true,
            //                 dropShadowColor: '#000000',
            //                 dropShadowBlur: 4,
            //                 dropShadowAngle: Math.PI / 6,
            //                 dropShadowDistance: 0,
            //                 wordWrap: true,
            //                 wordWrapWidth: 800
            //             }
            //         },
            //         {
            //             "id": "text_autoplay3",
            //             "name": "text_OnAnyWin",
            //             "type": "Text",
            //             "x": 560,
            //             "y": 253,
            //             "height": 100,
            //             "width": 220,
            //             "text": "autoplayText_3",
            //             "scaleToFit": false,
            //             "anchor": [0.5, 0.5],
            //             "textStyle": {
            //                 fontFamily: 'Arial',
            //                 fontSize: 17,
            //                 fontStyle: 'normal',
            //                 fontWeight: 'bold',
            //                 fill: ['#ffffff', '#ffffff', '#ffffff'], // gradient
            //                 stroke: '#4a1850',
            //                 strokeThickness: 0,
            //                 dropShadow: true,
            //                 dropShadowColor: '#000000',
            //                 dropShadowBlur: 4,
            //                 dropShadowAngle: Math.PI / 6,
            //                 dropShadowDistance: 0,
            //                 wordWrap: true,
            //                 wordWrapWidth: 800
            //             }
            //         },
            //         {
            //             "id": "text_autoplay4",
            //             "name": "text_freeSpinAreWon",
            //             "type": "Text",
            //             "x": 593,
            //             "y": 325,
            //             "height": 100,
            //             "width": 220,
            //             "text": "autoplayText_4",
            //             "scaleToFit": false,
            //             "anchor": [0.5, 0.5],
            //             "textStyle": {
            //                 fontFamily: 'Arial',
            //                 fontSize: 17,
            //                 fontStyle: 'normal',
            //                 fontWeight: 'bold',
            //                 fill: ['#ffffff', '#ffffff', '#ffffff'], // gradient
            //                 stroke: '#4a1850',
            //                 strokeThickness: 0,
            //                 dropShadow: true,
            //                 dropShadowColor: '#000000',
            //                 dropShadowBlur: 4,
            //                 dropShadowAngle: Math.PI / 6,
            //                 dropShadowDistance: 0,
            //                 wordWrap: true,
            //                 wordWrapWidth: 800
            //             }
            //         },
            //     ]
            //
            // },
            // {
            //     "id": "autoplayStoppedContainer",
            //     "name": "autoplayStoppedContainer",
            //     "type": "Container",
            //     "class": "",
            //     "visible": false,
            //     "x": 0,
            //     "y": 0,
            //     "filterTypes": [],
            //     child: [
            //         {
            //             "id": "text_autoplayStopped1",
            //             "name": "text_autoplayStopped1",
            //             "type": "Text",
            //             "x": 634,
            //             "y": 80,
            //             "height": 100,
            //             "width": 500,
            //             "text": "autoplayStoppedTextHeading",
            //             "scaleToFit": false,
            //             "anchor": [0.5, 0.5],
            //             "textStyle": {
            //                 fontFamily: 'Arial',
            //                 fontSize: 26,
            //                 fontStyle: 'normal',
            //                 fontWeight: 'bold',
            //                 fill: ['#d4af37', '#d4af37', '#d4af37'], // gradient
            //                 stroke: '#4a1850',
            //                 strokeThickness: 0,
            //                 dropShadow: true,
            //                 dropShadowColor: '#000000',
            //                 dropShadowBlur: 4,
            //                 dropShadowAngle: Math.PI / 6,
            //                 dropShadowDistance: 0,
            //                 wordWrap: true,
            //                 wordWrapWidth: 800
            //             }
            //         },
            //         {
            //             "id": "text_autoplayStopped2",
            //             "name": "text_autoplayStopped2",
            //             "type": "Text",
            //             "x": 650,
            //             "y": 200,
            //             "height": 100,
            //             "width": 200,
            //             "text": "autoplayStoppedText1",
            //             "scaleToFit": false,
            //             "anchor": [0.5, 0.5],
            //             "textStyle": {
            //                 fontFamily: 'Arial',
            //                 fontSize: 23,
            //                 fontStyle: 'normal',
            //                 fontWeight: 'bold',
            //                 fill: ['#ffffff'], // gradient
            //                 stroke: '#4a1850',
            //                 strokeThickness: 0,
            //                 dropShadow: true,
            //                 dropShadowColor: '#000000',
            //                 dropShadowBlur: 4,
            //                 dropShadowAngle: Math.PI / 6,
            //                 dropShadowDistance: 0,
            //                 wordWrap: true,
            //                 wordWrapWidth: 800
            //             }
            //         },
            //         {
            //             "id": "text_autoplayStopped3",
            //             "name": "text_autoplayStopped3",
            //             "type": "Text",
            //             "x": 650,
            //             "y": 240,
            //             "height": 100,
            //             "width": 200,
            //             "text": "autoplayStoppedText2",
            //             "scaleToFit": false,
            //             "anchor": [0.5, 0.5],
            //             "textStyle": {
            //                 fontFamily: 'Arial',
            //                 fontSize: 23,
            //                 fontStyle: 'normal',
            //                 fontWeight: 'bold',
            //                 fill: ['#ffffff'], // gradient
            //                 stroke: '#4a1850',
            //                 strokeThickness: 0,
            //                 dropShadow: true,
            //                 dropShadowColor: '#000000',
            //                 dropShadowBlur: 4,
            //                 dropShadowAngle: Math.PI / 6,
            //                 dropShadowDistance: 0,
            //                 wordWrap: true,
            //                 wordWrapWidth: 800
            //             }
            //         },
            //
            //     ]
            //
            // },
        ],
    }


};

export const AutoplayConfigurationContext = React.createContext(
    {}
);





